import { Endpoint } from "../config";

export type BankEndpointType = "getBanks";

export const bankEndpoints: Record<BankEndpointType, Endpoint> = {
  getBanks: {
    url: "bank/",
  },
};
